import { _ as __rest } from '../tslib.es6-17e0406b.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { styled, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';

const PREFIX = 'Question/Dialog';
const classes = {
    button: `${PREFIX}-button`,
};
const StyledButton = styled(Button)(({ theme }) => ({
    [`& .${classes.button}`]: {
        color: theme.palette.text.secondary,
    },
}));
const QuestionDialog = (_a) => {
    var { title, text, open, setOpen, primaryButtonText, primaryButtonOnClick, secondaryButtonText, secondaryButtonOnClick } = _a, rest = __rest(_a, ["title", "text", "open", "setOpen", "primaryButtonText", "primaryButtonOnClick", "secondaryButtonText", "secondaryButtonOnClick"]);
    return (jsxs(Dialog, Object.assign({ open: open, onClose: () => setOpen(false), "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" }, rest, { children: [jsx(DialogTitle, Object.assign({ id: "alert-dialog-title" }, { children: title })), jsx(DialogContent, { children: jsx(DialogContentText, Object.assign({ id: "alert-dialog-description" }, { children: text })) }), jsxs(DialogActions, { children: [jsx(Button, Object.assign({ onClick: () => primaryButtonOnClick(), autoFocus: true }, { children: primaryButtonText })), secondaryButtonOnClick && (jsx(StyledButton, Object.assign({ onClick: () => secondaryButtonOnClick(), className: classes.button }, { children: secondaryButtonText })))] })] })));
};

export { QuestionDialog };
